"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _activityGrid = _interopRequireDefault(require("../components/activity-grid"));
var _activityList = _interopRequireDefault(require("../components/activity-list"));
var _allergens = _interopRequireDefault(require("../components/allergens"));
var _bookmark = _interopRequireDefault(require("../components/bookmark"));
var _download = _interopRequireDefault(require("../components/download"));
var _eventSlider = _interopRequireDefault(require("../components/event-slider"));
var _form = _interopRequireDefault(require("../components/form"));
var _gallery = _interopRequireDefault(require("../components/gallery"));
var _greenLiving = _interopRequireDefault(require("../components/green-living"));
var _headline = _interopRequireDefault(require("../components/headline"));
var _html = _interopRequireDefault(require("../components/html"));
var _imagetext = _interopRequireDefault(require("../components/imagetext"));
var _infrastructureList = _interopRequireDefault(require("../components/infrastructure-list"));
var _infrastructureSlider = _interopRequireDefault(require("../components/infrastructure-slider"));
var _lateCheckOut = _interopRequireDefault(require("../components/late-check-out"));
var _list = _interopRequireDefault(require("../components/list"));
var _menu = _interopRequireDefault(require("../components/menu"));
var _phoneNumbers = _interopRequireDefault(require("../components/phone-numbers"));
var _references = _interopRequireDefault(require("../components/references"));
var _referenceButtons = _interopRequireDefault(require("../components/reference-buttons"));
var _singleimage = _interopRequireDefault(require("../components/singleimage"));
var _singleteaser = _interopRequireDefault(require("../components/singleteaser"));
var _suppliers = _interopRequireDefault(require("../components/suppliers"));
var _table = _interopRequireDefault(require("../components/table"));
var _team = _interopRequireDefault(require("../components/team"));
var _teaserGrid = _interopRequireDefault(require("../components/teaser-grid"));
var _teaserSlider = _interopRequireDefault(require("../components/teaser-slider"));
var _text = _interopRequireDefault(require("../components/text"));
var _themeTeaser = _interopRequireDefault(require("../components/theme-teaser"));
var _topMenuTeaser = _interopRequireDefault(require("../components/top-menu-teaser"));
var _userGreeting = _interopRequireDefault(require("../components/user-greeting"));
var _userInvitePerson = _interopRequireDefault(require("../components/user-invite-person"));
var _video = _interopRequireDefault(require("../components/video"));
var _weather = _interopRequireDefault(require("../components/weather"));
var _weeklyProgram = _interopRequireDefault(require("../components/weekly-program"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const parseElement = element => {
  const {
    id,
    tag
  } = element;
  switch (tag) {
    case "basic-headline":
      {
        return /*#__PURE__*/_react.default.createElement(_headline.default, {
          key: id,
          data: element
        });
      }
    case "basic-text":
      {
        return /*#__PURE__*/_react.default.createElement(_text.default, {
          key: id,
          data: element
        });
      }
    case "basic-list":
      {
        return /*#__PURE__*/_react.default.createElement(_list.default, {
          key: id,
          data: element
        });
      }
    case "basic-imagetext":
      {
        return /*#__PURE__*/_react.default.createElement(_imagetext.default, {
          key: id,
          data: element
        });
      }
    case "basic-singleimage":
      {
        return /*#__PURE__*/_react.default.createElement(_singleimage.default, {
          key: id,
          data: element
        });
      }
    case "basic-gallery":
      {
        return /*#__PURE__*/_react.default.createElement(_gallery.default, {
          key: id,
          data: element
        });
      }
    case "basic-teaser":
      {
        var _element$teasergroup2;
        if (element.variant === 1) {
          var _element$teasergroup;
          return /*#__PURE__*/_react.default.createElement(_teaserGrid.default, {
            key: id,
            data: element === null || element === void 0 || (_element$teasergroup = element.teasergroup) === null || _element$teasergroup === void 0 ? void 0 : _element$teasergroup.items
          });
        }
        return /*#__PURE__*/_react.default.createElement(_teaserSlider.default, {
          key: id,
          data: element === null || element === void 0 || (_element$teasergroup2 = element.teasergroup) === null || _element$teasergroup2 === void 0 ? void 0 : _element$teasergroup2.items
        });
      }
    case "basic-singleteaser":
      {
        return /*#__PURE__*/_react.default.createElement(_singleteaser.default, {
          key: id,
          data: element
        });
      }
    case "basic-links":
      {
        if (element.variant === 1) {
          return /*#__PURE__*/_react.default.createElement(_references.default, {
            key: id,
            data: element,
            hasBackground: true
          });
        }
        if (element.variant === 2) {
          return /*#__PURE__*/_react.default.createElement(_referenceButtons.default, {
            key: id,
            data: element
          });
        }
        return /*#__PURE__*/_react.default.createElement(_references.default, {
          key: id,
          data: element,
          isExtended: true
        });
      }
    case "basic-table":
      {
        return /*#__PURE__*/_react.default.createElement(_table.default, {
          key: id,
          data: element
        });
      }
    case "basic-video":
      {
        return /*#__PURE__*/_react.default.createElement(_video.default, {
          key: id,
          data: element
        });
      }
    case "basic-download":
      {
        return /*#__PURE__*/_react.default.createElement(_download.default, {
          key: id,
          data: element
        });
      }
    case "basic-html":
      {
        return /*#__PURE__*/_react.default.createElement(_html.default, {
          key: id,
          html: element === null || element === void 0 ? void 0 : element.text,
          id: id
        });
      }
    case "basic-form":
      {
        return /*#__PURE__*/_react.default.createElement(_form.default, {
          key: id,
          data: element
        });
      }
    case "extension-green-living":
      {
        return /*#__PURE__*/_react.default.createElement(_greenLiving.default, {
          key: id
        });
      }
    case "extension-late-check-out":
      {
        return /*#__PURE__*/_react.default.createElement(_lateCheckOut.default, {
          key: id
        });
      }
    case "tourism-activities":
      {
        var _items$find, _items$find2, _categories, _providers;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let categories = items === null || items === void 0 || (_items$find = items.find(_ref => {
          let {
            name
          } = _ref;
          return name === "valCategories";
        })) === null || _items$find === void 0 ? void 0 : _items$find.text;
        let providers = items === null || items === void 0 || (_items$find2 = items.find(_ref2 => {
          let {
            name
          } = _ref2;
          return name === "providers";
        })) === null || _items$find2 === void 0 ? void 0 : _items$find2.text;
        if (categories) categories = (_categories = categories) === null || _categories === void 0 || (_categories = _categories.split("|")) === null || _categories === void 0 ? void 0 : _categories.map(item => parseInt(item));
        if (providers) providers = (_providers = providers) === null || _providers === void 0 || (_providers = _providers.split("|")) === null || _providers === void 0 ? void 0 : _providers.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_activityList.default, {
          categories: categories,
          data: element,
          key: id,
          providers: providers
        });
      }
    case "tourism-infrastructures":
      {
        var _items$find3, _items$find4, _providers2, _selected;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find3 = items.find(_ref3 => {
          let {
            name
          } = _ref3;
          return name === "providers";
        })) === null || _items$find3 === void 0 ? void 0 : _items$find3.text;
        let selected = items === null || items === void 0 || (_items$find4 = items.find(_ref4 => {
          let {
            name
          } = _ref4;
          return name === "valInfrastructures";
        })) === null || _items$find4 === void 0 ? void 0 : _items$find4.text;
        if (providers) providers = (_providers2 = providers) === null || _providers2 === void 0 || (_providers2 = _providers2.split("|")) === null || _providers2 === void 0 ? void 0 : _providers2.map(item => parseInt(item));
        if (selected) selected = (_selected = selected) === null || _selected === void 0 || (_selected = _selected.split("|")) === null || _selected === void 0 ? void 0 : _selected.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_infrastructureSlider.default, {
          key: id,
          providers: providers,
          selected: selected
        });
      }
    case "tourism-top-menu-teaser":
      {
        var _items$find5, _providers3;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find5 = items.find(_ref5 => {
          let {
            name
          } = _ref5;
          return name === "providers";
        })) === null || _items$find5 === void 0 ? void 0 : _items$find5.text;
        if (providers) providers = (_providers3 = providers) === null || _providers3 === void 0 || (_providers3 = _providers3.split("|")) === null || _providers3 === void 0 ? void 0 : _providers3.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_topMenuTeaser.default, {
          data: element,
          key: id,
          providers: providers
        });
      }
    case "tourism-events":
      {
        var _items$find6, _categories2;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let categories = items === null || items === void 0 || (_items$find6 = items.find(_ref6 => {
          let {
            name
          } = _ref6;
          return name === "categories";
        })) === null || _items$find6 === void 0 ? void 0 : _items$find6.text;
        if (categories) categories = (_categories2 = categories) === null || _categories2 === void 0 || (_categories2 = _categories2.split("|")) === null || _categories2 === void 0 ? void 0 : _categories2.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_eventSlider.default, {
          categories: categories,
          data: element,
          key: id
        });
      }
    case "tourism-infrastructure":
      {
        var _items$find7, _items$find8, _categories3, _selected2;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let categories = items === null || items === void 0 || (_items$find7 = items.find(_ref7 => {
          let {
            name
          } = _ref7;
          return name === "categories";
        })) === null || _items$find7 === void 0 ? void 0 : _items$find7.text;
        let selected = items === null || items === void 0 || (_items$find8 = items.find(_ref8 => {
          let {
            name
          } = _ref8;
          return name === "selected";
        })) === null || _items$find8 === void 0 ? void 0 : _items$find8.text;
        if (categories) categories = (_categories3 = categories) === null || _categories3 === void 0 || (_categories3 = _categories3.split("|")) === null || _categories3 === void 0 ? void 0 : _categories3.map(item => parseInt(item));
        if (selected) selected = (_selected2 = selected) === null || _selected2 === void 0 || (_selected2 = _selected2.split("|")) === null || _selected2 === void 0 ? void 0 : _selected2.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_infrastructureList.default, {
          categories: categories,
          key: id,
          selected: selected
        });
      }
    case "theme-teaser":
      {
        return /*#__PURE__*/_react.default.createElement(_themeTeaser.default, {
          key: id,
          data: element
        });
      }
    case "extension-bookmark":
      {
        return /*#__PURE__*/_react.default.createElement(_bookmark.default, {
          key: id,
          data: element
        });
      }
    case "extension-team":
      {
        var _items$find9, _providers4;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find9 = items.find(_ref9 => {
          let {
            name
          } = _ref9;
          return name === "providers";
        })) === null || _items$find9 === void 0 ? void 0 : _items$find9.text;
        if (providers) providers = (_providers4 = providers) === null || _providers4 === void 0 || (_providers4 = _providers4.split("|")) === null || _providers4 === void 0 ? void 0 : _providers4.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_team.default, {
          data: element,
          key: id,
          providers: providers
        });
      }
    case "extension-weekly-program":
      {
        var _items$find10, _providers5;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find10 = items.find(_ref10 => {
          let {
            name
          } = _ref10;
          return name === "providers";
        })) === null || _items$find10 === void 0 ? void 0 : _items$find10.text;
        if (providers) providers = (_providers5 = providers) === null || _providers5 === void 0 || (_providers5 = _providers5.split("|")) === null || _providers5 === void 0 ? void 0 : _providers5.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_weeklyProgram.default, {
          data: element,
          key: id,
          providers: providers
        });
      }
    case "extension-allergens":
      {
        return /*#__PURE__*/_react.default.createElement(_allergens.default, {
          key: id,
          data: element
        });
      }
    case "tourism-suppliers":
      {
        var _items$find11, _providers6;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find11 = items.find(_ref11 => {
          let {
            name
          } = _ref11;
          return name === "providers";
        })) === null || _items$find11 === void 0 ? void 0 : _items$find11.text;
        if (providers) providers = (_providers6 = providers) === null || _providers6 === void 0 || (_providers6 = _providers6.split("|")) === null || _providers6 === void 0 ? void 0 : _providers6.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_suppliers.default, {
          key: id,
          providers: providers
        });
      }
    case "tourism-menu":
      {
        var _items$find12, _items$find13, _providers7, _selected3;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find12 = items.find(_ref12 => {
          let {
            name
          } = _ref12;
          return name === "providers";
        })) === null || _items$find12 === void 0 ? void 0 : _items$find12.text;
        let selected = items === null || items === void 0 || (_items$find13 = items.find(_ref13 => {
          let {
            name
          } = _ref13;
          return name === "valMenu";
        })) === null || _items$find13 === void 0 ? void 0 : _items$find13.text;
        if (providers) providers = (_providers7 = providers) === null || _providers7 === void 0 || (_providers7 = _providers7.split("|")) === null || _providers7 === void 0 ? void 0 : _providers7.map(item => parseInt(item));
        if (selected) selected = (_selected3 = selected) === null || _selected3 === void 0 || (_selected3 = _selected3.split("|")) === null || _selected3 === void 0 ? void 0 : _selected3.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_menu.default, {
          key: id,
          providers: providers,
          selected: selected
        });
      }
    case "user-greeting":
      {
        return /*#__PURE__*/_react.default.createElement(_userGreeting.default, {
          key: id,
          data: element
        });
      }
    case "user-invite-person":
      {
        return /*#__PURE__*/_react.default.createElement(_userInvitePerson.default, {
          key: id
        });
      }
    case "extension-weather":
      {
        return /*#__PURE__*/_react.default.createElement(_weather.default, {
          key: id
        });
      }
    case "tourism-activities-grid":
      {
        return /*#__PURE__*/_react.default.createElement(_activityGrid.default, {
          key: id
        });
      }
    case "extension-phonenumbers":
      {
        var _items$find14, _providers8;
        const {
          textcontent: {
            items = []
          } = {}
        } = element;
        let providers = items === null || items === void 0 || (_items$find14 = items.find(_ref14 => {
          let {
            name
          } = _ref14;
          return name === "providers";
        })) === null || _items$find14 === void 0 ? void 0 : _items$find14.text;
        if (providers) providers = (_providers8 = providers) === null || _providers8 === void 0 || (_providers8 = _providers8.split("|")) === null || _providers8 === void 0 ? void 0 : _providers8.map(item => parseInt(item));
        return /*#__PURE__*/_react.default.createElement(_phoneNumbers.default, {
          data: element,
          key: id,
          providers: providers
        });
      }
    default:
      console.info(element);
      return null;
  }
};
var _default = exports.default = parseElement;